import { CheckoutPricing } from '../../models/global-checkout/checkout-pricing.interface';

export const mockAchCheckoutPricing: CheckoutPricing = {
  taxRate: 3211,
  netFirstPaymentAmount: 350,
  netTotalAmount: 1277,
  taxTotalAmount: 3215,
  offerPricingKey: 3277,
  paymentProfileCode: 'mockPaymentProfileCode',
  discountProfileAttributes: {
    achDiscountCodeApplied: 'achDiscountCode',
    netAmountBeforeDiscount: 1000,
    netFirstPaymentAmountAfterPromotionalPeriod: 300,
  },
};
